<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button color="primary"
          printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
          Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
        <div class="container" id="print-section">
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; width: 100%; text-align: center; font-weight: bold;">
              <span style="grid-column: span 3; font-size: xx-large;">प्रतिनिधी पत्ते</span>
            </div>
          
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; width: 100%; font-weight: bold;">
              <!-- <span style="text-align: left; padding-left: 15px; margin-top: 15px;">अंक नाव :- {{}}</span>  -->
              <span style="text-align: left; margin-top: 15px; font-size: small;">अंक दिनांक :- {{ issueDates | date: 'dd-MM-yyyy' }}</span>
              <span style="text-align: left; margin-top: 50px; ">दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
            </div>
          
             <div class="row" style="display: flex; flex-wrap: wrap; margin-left: 25px;">
              <div *ngFor="let data1 of Address" class="col"
                   style="flex: 0 0 33.33%; padding: 10px; box-sizing: border-box; page-break-inside: avoid;">
                <b style="font-size: 20px;">{{ data1.issueSellerName }}</b><br>
                <span style="font-size: 16px;">{{ data1.address }}</span><br>
                <span style="font-size: 16px;">{{ data1.taluka }}</span><br>
                <span style="font-size: 16px;">{{ data1.district }}-{{ data1.pincode }} {{ data1.state }}</span><br>
                <b style="font-size: 16px;">मो.क्र.{{ data1.advt_mobile }}</b>
              </div>
            </div>
          </div>
          

</div>